module.exports = {
    computed: {

        prettyTotal: function() {
            if (this.changeorder) {
                let total = this.subtotal + this.tax;
                return this.numberWithCommas(parseFloat(total).toFixed(2));
            }
            return '0.00';
        },

        prettySubtotal: function() {
            if (this.changeorder) {
                return this.numberWithCommas(parseFloat(this.subtotal).toFixed(2));
            }
            return '0.00';
        },

        prettyTax: function() {
            if (this.changeorder) {
                return this.numberWithCommas(parseFloat(this.tax).toFixed(2));
            }
            return '0.00';
        },

        subtotal: function() {
            if (this.changeorder) {
                return parseFloat(this.changeorder.cost);
            }
            return 0;
        },

        tax: function() {
            if (this.project) {
                return parseFloat(this.subtotal * parseFloat(this.project.tax / 100));
            }
            return 0;
        },
    },

    methods: {
        numberWithCommas: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
};
